import React, { useCallback, useRef } from 'react'
import s from './QuickSearchInput.less'

const QuickSearchInput = ({ searchInputRef, onChange }) => {
  const quickInputRef = useRef()

  const handleChange = useCallback(
    event => {
      searchInputRef.current.focus()
      onChange({ value: event.target.value })
      quickInputRef.current.value = ''
    },
    [searchInputRef, onChange, quickInputRef]
  )
  return <input ref={quickInputRef} className={s.root} autoFocus={true} onChange={handleChange} />
}

export default QuickSearchInput
